import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=caae9f9e&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caae9f9e')) {
      api.createRecord('caae9f9e', component.options)
    } else {
      api.reload('caae9f9e', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=caae9f9e&", function () {
      api.rerender('caae9f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-277F3nLZsnLHu/JS/comp/ImgFallback2.vue"
export default component.exports